import React, { createContext, useContext } from 'react'
import { notification } from 'antd'

const NotificationContext = createContext(null)

export const useGlobalNotification = () => useContext(NotificationContext)

const NotificationProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification()

  const pushNotification = (type, message, description, duration = 1) => {
    if (['success', 'error', 'info', 'warning'].includes(type)) {
      api[type]({
        message,
        description,
        duration
      })
    } else {
      console.error('Invalid notification type:', type)
    }
  }

  return (
    <NotificationContext.Provider value={pushNotification}>
      {contextHolder} {/* This ensures notifications are displayed */}
      {children}
    </NotificationContext.Provider>
  )
}

export default NotificationProvider
